import { useEffect, useState } from "react";
import { confirmSentryDelivery } from "../sentry";
import { AppErrorScreen } from "./AppErrorScreen";

/**
 * The error screen, told the truth about the report: "we've been notified"
 * appears only after Sentry confirms its queue drained. React hands the
 * error to Sentry before this mounts (see sentry.ts), so the flush covers it.
 */
export function ReportedErrorScreen({ onRetry }: { readonly onRetry: () => void }) {
  const notified = useReportDelivered();
  return <AppErrorScreen notified={notified} onRetry={onRetry} />;
}

function useReportDelivered(): boolean {
  const [delivered, setDelivered] = useState(false);
  useEffect(() => {
    let cancelled = false;
    void confirmSentryDelivery().then((ok) => {
      if (!cancelled) setDelivered(ok);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return delivered;
}
